<template>
  <chart-card
    title="Média de itens na cesta"
    display-mode
    :is-pdf-content="isPdfContent"
    :data="chartData"
    :chart-loading="loading"
    legends
    :use-chart-type.sync="useCardChartType"
  />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  props: {
    groupBy: {
      type: String,
      default: 'monthly',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isPdfContent: {
      type: Boolean,
      default: false,
    },
    useChartType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    mediaItensClube: [],
    mediaItensForaClube: [],
  }),
  computed: {
    ...mapState({
      comparativoCharts: (state) => state.clube.comparativoCharts,
    }),
    useCardChartType: {
      get() {
        return this.useChartType
      },
      set(value) {
        this.$emit('update:useChartType', value)
      },
    },
    chartData() {
      const arrayClube = cloneDeep(this.mediaItensClube)
      const arrayForaClube = cloneDeep(this.mediaItensForaClube)

      /* Sometimes the array do not have matching dates. These 2 foreach statements
      fills in missing dates for both arrays */
      arrayClube.forEach((element, index) => {
        if (!arrayForaClube.find((el) => JSON.stringify(el.data) === JSON.stringify(element.data))) {
          arrayForaClube.splice(index, 0, { ...element, valor: 0.0 })
        }
      })
      arrayForaClube.forEach((element, index) => {
        if (!arrayClube.find((el) => JSON.stringify(el.data) === JSON.stringify(element.data))) {
          arrayClube.splice(index, 0, { ...element, valor: 0.0 })
        }
      })

      return {
        labels: [...arrayForaClube.map((object) => object.data)],
        datasets: [
          {
            label: 'Média de itens na cesta - clube',
            backgroundColor: colors[1],
            strokeColor: colors[1],
            borderColor: colors[1],
            data: [...arrayClube.map((object) => object.valor)],
            fill: false,
          },
          {
            label: 'Média de itens na cesta - fora do clube',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...arrayForaClube.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    comparativoCharts() {
      this.formatData()
    },
  },
  mounted() {
    this.formatData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.formatData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    formatData() {
      if (this.groupBy === 'monthly') {
        this.mediaItensClube = helpers.agrupamentoMensal(this.comparativoCharts, 'VAL_MEDIA_ITENS_CESTA_FIDELIDADE')
        this.mediaItensForaClube = helpers.agrupamentoMensal(this.comparativoCharts, 'VAL_MEDIA_ITENS_CESTA_NAO_FIDELIDADE')
      }

      if (this.groupBy === 'weekly') {
        this.mediaItensClube = helpers.agrupamentoSemanal(this.comparativoCharts, 'VAL_MEDIA_ITENS_CESTA_FIDELIDADE')
        this.mediaItensForaClube = helpers.agrupamentoSemanal(this.comparativoCharts, 'VAL_MEDIA_ITENS_CESTA_NAO_FIDELIDADE')
      }

      if (this.groupBy === 'daily') {
        this.mediaItensClube = helpers.agrupamentoDiario(this.comparativoCharts, 'VAL_MEDIA_ITENS_CESTA_FIDELIDADE')
        this.mediaItensForaClube = helpers.agrupamentoDiario(this.comparativoCharts, 'VAL_MEDIA_ITENS_CESTA_NAO_FIDELIDADE')
      }
    },
  },
}
</script>
